import {axiosClient} from "./client";
import {GET_COUNTRY_WISE_EXPERTS} from "./client/endpoints";

const fetchCountryWiseExperts = async (payload: any): Promise<any> => {
  try {
    const response = await axiosClient.post<any>(
      GET_COUNTRY_WISE_EXPERTS,
      payload
    );
    return response.data;
  } catch (e) {
    return null;
  }
};

const ExpertsCountryService = {
  fetchCountryWiseExperts,
};

export default ExpertsCountryService;
